module.exports = __webpack_public_path__ + "c31a234243c6a12febf58a7708b44df3.png";